"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isFunctionComponent = exports.isClassComponent = void 0;

var isClassComponent = function isClassComponent(component) {
  return typeof component === 'function' && !!component.prototype.isReactComponent;
};

exports.isClassComponent = isClassComponent;

var isFunctionComponent = function isFunctionComponent(component) {
  return typeof component === 'function' && String(component).includes('createElement');
};

exports.isFunctionComponent = isFunctionComponent;

var isReactComponent = function isReactComponent(component) {
  return isClassComponent(component) || isFunctionComponent(component);
};

var _default = isReactComponent;
exports.default = _default;